// extracted by mini-css-extract-plugin
export default {"cls1":"PageHeader-Title_cls1__ntpw6","cls2":"PageHeader-Title_cls2__dJCd4 PageHeader-Title_cls1__ntpw6"};